export default "__VITE_ASSET__BOf3IwZf__"